import { CancelResComponent, CancelConfComponent, ModifyResComponent, ManageStayComponent, StayPrefComponent, WriteReviewComponent, SubmitReviewComponent } from './routes';
import { Inject, NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RedirectorComponent } from '../app/components/redirector';
import {ApplicationRouteNames} from './common/model/application-route-names.model';
import { FeatureFlagsService } from '../app/api/services/feature-flags.service';
import { APP_CONFIG } from './api/config/app.config';
import { AppConfig } from './api/config/AppConfig';
import { environment } from '../environments/environment';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'prefix',
    resolve: {
      flags: FeatureFlagsService
    },
    children: [
      {
        path: ApplicationRouteNames.CANCEL_RESERVATION, component: RedirectorComponent, pathMatch: 'full',
      },
      {
        path: ApplicationRouteNames.CANCEL_RESERVATION + '/:id', component: RedirectorComponent, pathMatch:  'full',
      },
      {
        path: ApplicationRouteNames.CANCEL_CONFIRMATION,
        component: RedirectorComponent, pathMatch: 'full',
      },
      {
        path: ApplicationRouteNames.CANCEL_CONFIRMATION + '/:id',
        component: RedirectorComponent, pathMatch: 'full',
      },
      {
        path: ApplicationRouteNames.CHANGE_RESERVATION , component: RedirectorComponent, pathMatch: 'full',
      },
      {
        path: ApplicationRouteNames.CHANGE_RESERVATION + ':id', component: RedirectorComponent, pathMatch:  'full',
      },
      {
        path: ApplicationRouteNames.STAY_PREFERENCES, component: RedirectorComponent, pathMatch: 'full'
      },
      {
        path: ApplicationRouteNames.STAY_PREFERENCES + '/:id', component: RedirectorComponent, pathMatch:  'full'
      },
      {
        path: ApplicationRouteNames.CANCEL_RESERVATION + '/:id/:lastName',
        component: CancelResComponent,
      },
      {
        path: ApplicationRouteNames.CANCEL_CONFIRMATION + '/:id/:lastName',
        component: CancelConfComponent,
      },
      {
        path: ApplicationRouteNames.CHANGE_RESERVATION + '/:id/:lastName',
        component: ModifyResComponent,
      },
      {
        path: ApplicationRouteNames.MANAGE_YOUR_STAY + '/:id/:lastName',
        component: ManageStayComponent,
        pathMatch: 'full'
      },
      {
        path: ApplicationRouteNames.MANAGE_YOUR_STAY,
        component: ManageStayComponent,
        pathMatch: 'full'

      },
      {
        path: ApplicationRouteNames.STAY_PREFERENCES + '/:id/:lastName',
        component: StayPrefComponent
      },
      {
        path: ApplicationRouteNames.WRITE_REVIEW,
        component: WriteReviewComponent
      },
      {
        path: ApplicationRouteNames.SUBMIT_REVIEW,
        component: SubmitReviewComponent
      },
    ]
  },
  {
    path: '**',
    component: RedirectorComponent,
    resolve: {
      flags: FeatureFlagsService,
    }
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [
    FeatureFlagsService,
    {
      provide: 'contact',
      useValue: () => {
        return {
          id: 1,
          name: 'Some Contact',
          website: 'http://some.website.com'
        };
      }
    }
  ]

})
export class AppRoutingModule {  
  constructor(@Inject(APP_CONFIG) private appConfig: AppConfig) {
  __webpack_require__.p = `/resources/${appConfig.locale.country}/${appConfig.locale.language}/stay-mgmt/v12.0.0/`;
}}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/app-routing.module.ts